import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const StudioContext = createContext(null);
const KEY = "flapi_active_studio";

export function StudioProvider({ children }) {
  const [studios, setStudios] = useState([]);
  const [activeId, setActiveId] = useState(localStorage.getItem(KEY) || "studio-flapi");
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/studios");
      setStudios(data);
      const ids = data.map((s) => s.id);
      if (!ids.includes(activeId) && data.length) {
        const first = data.find((s) => s.is_default)?.id || data[0].id;
        setActiveId(first);
        localStorage.setItem(KEY, first);
      }
    } catch (e) {
      // not authenticated yet
    } finally {
      setLoading(false);
    }
  }, [activeId]);

  useEffect(() => { refresh(); }, []); // eslint-disable-line

  const switchStudio = (id) => {
    localStorage.setItem(KEY, id);
    setActiveId(id);
  };

  const active = studios.find((s) => s.id === activeId) || { id: activeId, name: "PinPilot", emoji: "🧙", color: "#00E5FF" };

  return (
    <StudioContext.Provider value={{ studios, active, activeId, switchStudio, refresh, loading }}>
      {children}
    </StudioContext.Provider>
  );
}

export const useStudio = () => useContext(StudioContext);
